<template>
  <WdsStack
    justify-start
    align-center
    gap-xs
    class="hire-owners"
    :class="{ 'tw-flex-wrap': expanded }"
    data-test="hire-owners"
  >
    <slot name="prefix" />
    <WdsText
      v-for="(owner, index) in visibleOwners"
      :key="owner.id"
      :class="{ 'tw-text-nowrap': !expanded }"
      data-test="hire-owner"
    >
      <span v-if="index < visibleOwners.length - 1">{{ owner.user.name }},</span>
      <span v-else>{{ owner.user.name }}</span>
    </WdsText>
    <WdsButtonGhost v-if="hiddenCount > 0" data-test="hire-owners-expand" @click="expanded = true">
      <WdsLabel :title="$t('See all hire owners')" xs subtle>+{{ hiddenCount }}</WdsLabel>
    </WdsButtonGhost>
    <WdsButtonGhost v-if="expanded" data-test="hire-owners-collapse" @click="expanded = false">
      <WdsLabel xs subtle>{{ $t('Show less') }}</WdsLabel>
    </WdsButtonGhost>
    <slot name="actions" />
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsLabel, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { FragmentType, graphql, useFragment } from '@/gql'

const HireOwnersListFragment = graphql(`
  fragment HireOwnersList on Owner {
    id
    user {
      id
      name
    }
  }
`)

const props = withDefaults(
  defineProps<{ owners: FragmentType<typeof HireOwnersListFragment>[]; limit?: number }>(),
  { limit: 2 },
)

const expanded = defineModel<boolean>('expanded', { default: false })

const owners = computed(() => useFragment(HireOwnersListFragment, props.owners))

const visibleOwners = computed(() =>
  expanded.value ? owners.value : owners.value.slice(0, props.limit),
)

const hiddenCount = computed(() => owners.value.length - visibleOwners.value.length)
</script>

<style lang="scss" scoped>
.hire-owners {
  &:deep(.wds-button-ghost) {
    padding: 0;
  }
}
</style>
